import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterField } from './filter-field.interface';


@Component({
  selector: 'app-generic-filter',
  templateUrl: './generic-filter.component.html',
  styleUrls: ['./generic-filter.component.scss']
})
export class GenericFilterComponent implements OnInit {
  @Input() filterForm!: FormGroup;
  @Input() fields: FilterField[] = [];
  @Input() showClearButton: boolean = true;
  @Input() clearButtonText: string = '$general.btnClearFilters';
  @Input() clearButtonIcon: string = 'fa-filter-circle-xmark';

  @Output() onClear = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Verificar si un campo está deshabilitado
   */
  isFieldDisabled(field: FilterField): boolean {
    if (typeof field.disabled === 'function') {
      return field.disabled();
    }
    return field.disabled || false;
  }

  /**
   * Emitir evento de limpiar filtros
   */
  clearFilters(): void {
    this.onClear.emit();
  }
}
